// import * as types from "../mutation-type";
// import {instance} from 'src/config/axiosConfig.js'


const state = {
    keyword: "", //搜索关键字
    searchTip:"", //搜索提示文字
};

const mutations = {
    // [types.GETKEYWORD] (state,str) {  //改变关键字
    //     state.keyword = str;
    // },
    // changeTip(state,str){
    //     state.searchTip = str;
    // }
};

const actions = {
    // getKeyword:({commit},str) => { //刷新关键字   
    //     commit(types.GETKEYWORD,str);
    // },
    // getSearchTip({commit},str){
    //     commit('changeTip',str);
    // }   
};
export default {
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/search.js